/**
 * useOperatori / usePartiteIva (PR5).
 */

import { useQuery } from '@tanstack/react-query';
import { listOperatori, type OperatoreRecord } from '../services/operatori';
import {
  listPartiteIva,
  getPartitaIvaPredefinita,
  type PartitaIvaRecord,
} from '../services/partite-iva';

export function useOperatori(opts?: { attiviSolo?: boolean }) {
  return useQuery<OperatoreRecord[]>({
    queryKey: ['operatori', opts?.attiviSolo ?? false] as const,
    queryFn: () => listOperatori(opts),
    staleTime: 5 * 60_000,
  });
}

export function usePartiteIva(opts?: { attiveSolo?: boolean }) {
  return useQuery<PartitaIvaRecord[]>({
    queryKey: ['partite_iva', opts?.attiveSolo ?? false] as const,
    queryFn: () => listPartiteIva(opts),
    staleTime: 5 * 60_000,
  });
}

/**
 * Ritorna la P.IVA predefinita di sistema (ATTIVA + predefinita=true).
 * Usato in lettura per mostrare l'auto-fill al paziente senza override.
 */
export function usePartitaIvaPredefinita() {
  return useQuery<PartitaIvaRecord | null>({
    queryKey: ['partita_iva_predefinita'] as const,
    queryFn: getPartitaIvaPredefinita,
    staleTime: 5 * 60_000,
  });
}
